// @flow
import { dateString } from '../date';
import type { Customer } from '../customer';
import type { AbstractCatalog } from '../abstract-catalog';
import { startBrowserDownload } from './http';

export const exportAvailability = ({
  catalog,
  customer,
  date,
  futureAvailableData = false,
}: $ReadOnly<{|
  catalog: AbstractCatalog,
  customer: Customer,
  date: Date,
  futureAvailableData?: boolean,
|}>): void => {
  // This is probably not the correct way, but this is a one-off
  const requestParams = new URLSearchParams({
    'csv[customer]': customer.number,
    'csv[data]': 'availability',
    'csv[date]': dateString(date),
    'csv[include_future_date]': futureAvailableData.toString(),
  });
  // eslint-disable-next-line no-underscore-dangle
  const requestURL = `/api/catalogs//${
    catalog._id
  }.csv?${requestParams.toString()}`;
  startBrowserDownload(requestURL);
};
